import React, { useState, useEffect } from "react";
import { useMsal, useIsAuthenticated, AuthenticatedTemplate, UnauthenticatedTemplate, useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { useNavigate } from 'react-router-dom';
import clientHttp from '../components/ClientHttp';
import secureLocalStorage from "react-secure-storage";
import { loginRequest } from '../authConfig';

export default function AuthEntraId() {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const isAuthenticated = useIsAuthenticated();

    const navigate = useNavigate();
    const [isLogin, setIsLogin] = useState(false);

    const [userInfo, setUserInfo] = useState(null);
    async function verifyUser(username) {
        console.log('verify user with username: ' + username)
        let result = null;
        const formData = {
            username: username,
            tokenId: ''
        }
        await clientHttp.post('auth/v1/verifyuser', formData
        ).then(response => {
            console.log('login status: ' + response.status)
            result = response.data
        }).catch(err => {
            console.log('login failed')
        })
        return result
    }

    async function menuPermissionByUser(token, roleid) {
        console.log('get menu permission by user with role: ' + roleid)
        let result = null;
        await clientHttp.get('user/v1/rolemenubyroleid', {
            params: { roleId: roleid },
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            console.log('get menu permission status: ' + response.status)
            result = response.data.data
        }).catch(err => {
            console.log('get menu permission failed')
        })
        return result
    }

    const handleLogoutRedirect = () => {
        instance.logoutRedirect().catch((error) => console.log(error));
    };

    const handleRedirect = () => {
        console.log('call login ...')
        setIsLogin(true)

        instance
            .loginRedirect({
                ...loginRequest,
                prompt: 'create',
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        console.log('use effect')

        if (isAuthenticated) {

            (async () => {
                const preferred_username = activeAccount.idTokenClaims['preferred_username']
                console.log(preferred_username)
                setUserInfo(preferred_username)

                try {
                    let username = preferred_username.toLocaleUpperCase()
                    let inx = username.indexOf("@")
                    if (inx > 0) {
                        username = username.substring(0, inx)
                    }
                    console.log('verify user with name: ' + username)
                    let result = await verifyUser(username);
                    console.log('verify result')
                    console.log(result)

                    //console.log('verify result status: ' + result.status)
                    if (result && result.status === 'success') {
                        localStorage.setItem('name', username)
                        localStorage.setItem('email', preferred_username)
                        localStorage.setItem('token', result.token)
                        //localStorage.setItem('roletype', result.roletype)
                        //localStorage.setItem('roleid', result.roleid)

                        // get menu permission
                        let menuperm = await menuPermissionByUser(result.token, result.roleid)
                        // if user is admin type, set full access
                        if (result.roletype === 'admin' && menuperm && menuperm.length > 0) {
                            for (let i = 0; i < menuperm.length; i++) {
                                menuperm[i].roleid = 999
                                menuperm[i].readflag = 'Y'
                                menuperm[i].writeflag = 'Y'
                            }
                        }
                        secureLocalStorage.setItem('menuperm', JSON.stringify(menuperm))
                        //console.log(menuperm)

                        navigate(process.env.REACT_APP_FIRST_PAGE)
                    } else {
                        navigate(process.env.REACT_APP_UNAUTHORIZE_PAGE)
                    }
                } catch (err) {
                    console.error(err);
                }
            })();

        }
    }, [isAuthenticated])

    const {login, result, error} = useMsalAuthentication(InteractionType.Redirect);

    return (
        <div className="container text-center">
            <div className="row justify-content-md-center m-5">
                <img src="/assets/img/amway-logo.jpg" style={{ width: 300 }} alt="Logo" />
            </div>
            <div className="row justify-content-md-center m-5">
                <h5>Authentication by Entra ID</h5>
                <AuthenticatedTemplate>
                    <>
                        <div className="mt-3">
                            <div className="spinner-border spinner-border-sm text-secondary d-inline-block" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div className="ms-3 d-inline-block">Verifying ... {userInfo}</div>
                        </div>
                        <div className="mt-3">
                            <button type="button" className="btn btn-primary btn-sm" onClick={handleLogoutRedirect}> Logout </button>
                        </div>
                    </>
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                    <div className="mt-3">
                        {isLogin ?
                            <button className="btn btn-black btn-border btn-sm" style={{ "width": "120" }} type="button">
                                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                <span role="status" className="ms-3">Logging in ...</span>
                            </button>
                            :
                            <button type="button" className="btn btn-primary btn-sm" style={{ "width": "120" }} onClick={handleRedirect}>
                                <i class="bi bi-person-circle"></i> <span role="status">Login</span>
                            </button>
                        }
                    </div>
                </UnauthenticatedTemplate>
            </div>
        </div>
    )
}